var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasicLayout',{attrs:{"left":_vm.left,"middle":_vm.middle,"right":_vm.right},scopedSlots:_vm._u([{key:"right_view",fn:function(){return [_c('DeployedTable',{ref:"deployedTable"})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }